import React from "react";
import PropTypes from "prop-types";

function getProgramStatus(startDate, endDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T23:59:59`);

  if (today < start) {
    return "Upcoming";
  }

  if (today <= end) {
    return "In Progress";
  }

  return "Completed";
}

function getStatusClass(status) {
  switch (status.toLowerCase()) {
    case "in progress":
      return "text-bg-success";

    case "upcoming":
      return "text-bg-primary";

    case "completed":
      return "text-bg-secondary";

    default:
      return "text-bg-secondary";
  }
}

function BasketballProgramCard({ program }) {
  const {
    title,
    description,
    ageGroup,
    startDate,
    endDate,
    dates,
    duration,
    time,
    singleDay,
    fullProgram,
    dropIn,
    location,
    locationUrl,
    registration
  } = program;

  const status = getProgramStatus(startDate, endDate);

  return (
    <article className="basketball-program-card">
      <div className="basketball-program-card__header">
        <h3 className="basketball-program-card__title futuraPTBold">
          {title}
        </h3>
        <span
          className={`badge rounded-pill ${getStatusClass(
            status
          )} basketball-program-card__status`}
        >
          {status}
        </span>
      </div>

      <p className="basketball-program-card__description futuraPTBook">
        {description}
      </p>

      <div className="row gy-4">
        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Age Group:
          </span>

          <span className="basketball-program-card__value">
            {ageGroup}
          </span>
        </div>

        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Dates:
          </span>

          <span className="basketball-program-card__value">
            {dates}
          </span>
        </div>

        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Duration:
          </span>

          <span className="basketball-program-card__value">
            {duration}
          </span>
        </div>

        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Time:
          </span>

          <span className="basketball-program-card__value">
            {time}
          </span>
        </div>

        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Single Day:
          </span>

          <span className="basketball-program-card__value">
            {singleDay}
          </span>
        </div>

        <div className="col-12 col-md-4">
          <span className="basketball-program-card__label">
            Drop In:
          </span>

          <span className="basketball-program-card__value">
            {dropIn}
          </span>
        </div>

        <div className="col-12">
          <span className="basketball-program-card__label">
            Full Program:
          </span>

          <span className="basketball-program-card__value">
            {fullProgram}
          </span>
        </div>

        <div className="col-12">
          <span className="basketball-program-card__label">
            Location:
          </span>

          <a
            href={locationUrl}
            target="_blank"
            rel="noreferrer"
            className="basketball-program-card__location"
          >
            {location}
          </a>
        </div>

        <div className="col-12">
          <a
            href={registration}
            target="_blank"
            rel="noreferrer"
            className="basketball-program-card__register-button"
          >
            Click Here to Register Now
          </a>
        </div>
      </div>
    </article>
  );
}

BasketballProgramCard.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ageGroup: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    dates: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    singleDay: PropTypes.string.isRequired,
    fullProgram: PropTypes.string.isRequired,
    dropIn: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    locationUrl: PropTypes.string.isRequired,
    registration: PropTypes.string.isRequired
  }).isRequired
};

export default BasketballProgramCard;